'use strict'

angular
  .module('basalteApp')
  .constant('BAS_WEB_SERVER', {
    EVT_INCOMING_REQUEST: 'evtHttpMessageRequest'
  })
